import { render } from "./BlogPreview.vue?vue&type=template&id=63f12884&scoped=true"
import script from "./BlogPreview.vue?vue&type=script&lang=js"
export * from "./BlogPreview.vue?vue&type=script&lang=js"

import "./BlogPreview.vue?vue&type=style&index=0&id=63f12884&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f12884"]])

export default __exports__